import { MatExpansionPanel } from '@angular/material/expansion';
import { Directive, Input, ElementRef, OnInit } from '@angular/core';
import { TutorialService } from 'src/app/core/tutorial/tutorial.service';

@Directive({
    selector: '[tutorialHighlightTarget]'
})
export class TutorialHighlightTargetDirective implements OnInit {
    @Input('tutorialHighlightTarget') targetId!: string;

    constructor(
        private tutorialService: TutorialService,
        private el: ElementRef
    ) { }

    ngOnInit() {
        if (this.targetId) {
           // this.tutorialService.registerHighlightTarget(this.targetId, this.el);
        }
    }
}